import { translateSafely } from "@ankaadia/ankaadia-shared-frontend";
import { ChangeDetectionStrategy, Component, effect, model } from "@angular/core";
import { SelectButton } from "primeng/selectbutton";
import { Tooltip } from "primeng/tooltip";
import { FormsModule } from "@angular/forms";

export enum ViewModeOption {
  Default = "Default",
  Compact = "Compact",
}

const View_Mode_Key = "AnkaadiaViewMode";

@Component({
  selector: "new-ui-view-mode-switch",
  imports: [SelectButton, Tooltip, FormsModule],
  templateUrl: "./new-ui-view-mode-switch.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewUiViewModeSwitchComponent {
  selectedMode = model<ViewModeOption>();

  protected readonly options = [
    {
      icon: "icon-[mi--column-resize-square]",
      value: ViewModeOption.Compact,
      tooltip: translateSafely("viewModeOption.compact"),
    },
    {
      icon: "icon-[mi--window-finder-maximize-resize]",
      value: ViewModeOption.Default,
      tooltip: translateSafely("viewModeOption.default"),
    },
  ];

  setMode = effect(() => {
    const current = this.selectedMode();
    const saved = <ViewModeOption>localStorage.getItem(View_Mode_Key);

    if (!current) {
      if (saved) this.selectedMode.set(saved);
      else this.selectedMode.set(ViewModeOption.Compact);
    } else if (current != saved) localStorage.setItem(View_Mode_Key, current);
  });
}
